<template>
  <div class="addagreement">
    <div v-if="showtips" class="submittips">*感谢您对我们的信任，选择前来我院就诊！请您仔细阅读并充分理解<span v-if="sectiontips">《门诊常规同意书》</span>《个人信息处理知情同意书》，如您同意其全部内容，请点击勾选框开始使用我们的产品和服务。</div>
    <div class="agree-form-item">
      <a-checkbox :checked="value" @change="change">我已阅读并同意</a-checkbox>
      <span v-if="section" class="agreement" @click="gotoAgreement('section')">《门诊常规同意书》</span>
      <span v-if="showpersonal" class="agreement" @click="gotoAgreement('360')">《个人信息处理知情同意书》</span>
    </div>
    <a-modal v-model="agreement.show" :title="agreement.title" @cancel="agreementModalCancel" 
      centered :footer="null" wrapClassName="agreementwrap"
      width="90%" :bodyStyle="{}"
    >
      <template v-if="agreement.type=='section'">
        <CdConsent v-if="hospital=='cd'"></CdConsent>
        <SzConsent v-else-if="hospital=='sz'"></SzConsent>
        <HfConsent v-else></HfConsent>
      </template>
      <template v-else>
        <div class="framebox" style="height: 600px;">
          <iframe id="frameAgree" :src="agreement.href" frameborder="0" width="100%" height="100%"></iframe>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import HfConsent from "@/components/agreement/consent/hfConsent.vue";
import CdConsent from "@/components/agreement/consent/cdConsent.vue";
import SzConsent from "@/components/agreement/consent/szConsent.vue";

const sectionUrl = {
  hf: 'https://ssc.boe.com/html/ohealth/medicalService/agreement',
  cd: 'https://ssc.boe.com/html/boeHospital/consent',
  sz: 'https://ssc.boe.com/html/H06-medical/consent'
}
const AGREEMENT_SECTION = {
  title: '《门诊常规同意书》',
  href: 'https://ssc.boe.com/html/ohealth/medicalService/agreement'
}
const AGREEMENT_360 = {
  title: '《个人信息处理知情同意书》',
  // href: 'https://ssc.boe.com/html/ohealth/pdf-preview.html?pdfUrl=https://sscobj.boe.com/online-file-service/ohealth/17318917-3fd5-4867-80ff-ea97b0d05dc6.pdf&type=preview'
}
export default {
  name: "add-person-agreement",
  components:{
    HfConsent,
    CdConsent,
    SzConsent,
  },
  // props:["value", "section"],
  props: {
    // 是否选中
    value: {
      type: Boolean,
      default: false,
    },
    // 医院简称 hf、cd、sz
    hospital: {
      default: ''
    },
    // 是否显示《门诊常规同意书》勾选框
    section: {
      default: false,
    },
    // 是否显示《个人信息处理知情同意书》
    showpersonal: {
      default: true,
    },
    // 是否显示提示文本
    showtips: {
      default: true,
    },
    // 是否显示《门诊常规同意书》提示文案
    sectiontips: {
      default: false,
    },
    // 360协议地址
    michref: {
      default: ''
    }
  },
  data() {
    return {
      // 协议详情弹框
      agreement: {
        show: false,
        title: '',
        href: ''
      },
    };
  },
  mounted() {
  },
  methods: {
    change() {
      this.$emit("input", !this.value);
    },
    gotoAgreement(type) {
      this.$emit("goto", type);
    },
    // 打开弹窗-阅读协议
    gotoAgreement(type) {
      switch (type) {
        case 'section': 
          this.agreement = {
            type: 'section',
            show: true,
            ...AGREEMENT_SECTION,
            href: sectionUrl[this.hospital],
          }
          break;
        case '360': 
          this.agreement = {
            type: '360',
            show: false,
            ...AGREEMENT_360,
            href: this.michref,
          }
          window.open(this.agreement.href)
          break;
        default: 
      }
    },
    // 关闭弹窗-阅读协议
    agreementModalCancel() {
      this.agreement = {
        show: false,
        title: '',
        href: '',
      }
    },
  }
};
</script>

<style lang="less" scoped>
.addagreement {
  .submittips {
    color: #F59A23;
    margin-bottom: 10px;
  }
  .agreement {
    color: blue;
    cursor: pointer;
    text-decoration: underline;
  }
}
.m-screen-pc {
}
.m-screen-mobile {
}
</style>
